module.exports = __webpack_public_path__ + "img/bg_text.2471726d.png";